"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9729,1759],{

/***/ 1759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18132);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72509);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3382);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);










const Breadcrumbs = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 624).then(__webpack_require__.bind(__webpack_require__, 33053)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(33053)]
  }
});
const Autocomplete = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(3344), __webpack_require__.e(3292), __webpack_require__.e(9653), __webpack_require__.e(804), __webpack_require__.e(1521), __webpack_require__.e(6350), __webpack_require__.e(7553)]).then(__webpack_require__.bind(__webpack_require__, 63070)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(63070)]
  }
});

const PageHeaderContainer = _ref => {
  let {
    title,
    description,
    crumbs,
    linkHref,
    linkTitle,
    searchAutoCompleteItems = [],
    domain,
    resultFormatter
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)();
  const isMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
      display: {
        base: 'none',
        md: 'flex'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Breadcrumbs, {
        items: crumbs
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Heading */ .X6, {
      as: "h1",
      fontSize: "2xl",
      fontFamily: "Montserrat-SemiBold",
      textAlign: "left",
      px: "l",
      pt: {
        base: 'l',
        md: '0'
      },
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
      px: "l",
      pt: "s",
      pb: "l",
      display: {
        md: 'flex'
      },
      tabIndex: -1,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        width: {
          base: '100%',
          md: '65%'
        },
        textAlign: "left",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
          marginTop: "s",
          color: "baseNeutral.700",
          fontFamily: "Montserrat-Medium",
          fontSize: "md",
          className: "landing-text",
          display: "inline",
          dangerouslySetInnerHTML: {
            __html: description
          }
        }), linkHref && linkTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(src_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          href: linkHref,
          title: linkTitle,
          color: "primaryGreen.600",
          fontFamily: "Montserrat-SemiBold",
          marginLeft: "0.75rem",
          children: [linkTitle, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_8__/* .ArrowForwardIcon */ .mr, {})]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        width: {
          base: '100%',
          md: '35%'
        },
        alignItems: "center",
        pl: {
          base: '0',
          md: 'l'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Autocomplete, {
          items: searchAutoCompleteItems,
          disableFilter: true,
          apiPath: domain === 'sell' ? 'search/sell/term' : 'search/rent/term',
          onSelect: selected => domain === 'sell' ? next_router__WEBPACK_IMPORTED_MODULE_2___default().push(selected) : next_router__WEBPACK_IMPORTED_MODULE_2___default().push(`/noleggio-a-lungo-termine/${selected.replace(' ', '/')}`),
          placeholder: isMobile ? t('pageHeaderContainer:placeholderMobile') : t('pageHeaderContainer:placeholder'),
          notFoundText: t('pageHeaderContainer:nothingFound'),
          withOverlay: true,
          mt: {
            base: 4,
            md: 0
          },
          resultFormatter: resultFormatter
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (PageHeaderContainer);

/***/ }),

/***/ 72509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53918);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


const _excluded = ["children", "href", "title", "target", "color", "fontFamily", "fontSize", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const StylesLink = /*#__PURE__*/styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
  componentId: "sc-vy2q48-0"
})(["& svg{display:inline;}"]);

const TextLink = _ref => {
  let {
    children,
    href,
    title,
    target,
    color,
    fontFamily,
    fontSize,
    style
  } = _ref,
      props = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StylesLink, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, _objectSpread(_objectSpread({
      color: color || 'baseWhite',
      title: title,
      target: target || '_self',
      fontFamily: fontFamily ? fontFamily : 'Montserrat-Medium',
      fontSize: fontSize ? fontSize : '1rem',
      letterSpacing: "0.3px",
      display: "inline",
      _hover: {
        textDecoration: 'none'
      }
    }, props), {}, {
      href: href,
      children: children
    }))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (TextLink);

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);